import { ColDef, ICellRendererParams } from 'ag-grid-community'
import clsx from 'clsx'
import { ColDefWithLoading, CurrencyCell } from 'components/core-v2'

import { formatUnits } from '@/utilities/number'

const StatusCell = ({ data: { state } }: ICellRendererParams<{ state: string }>) => (
  <span className={clsx({ positive: state === 'Confirmed' })}>{state}</span>
)

export const COLUMN_DEFS: ColDefWithLoading[] = [
  {
    headerName: 'Status',
    field: 'state',
    minWidth: 140,
    flex: 0.1,
    cellRenderer: StatusCell,
    loadingCellWidth: 'sm'
  },

  {
    headerName: 'Asset ID',
    field: 'assetId',
    minWidth: 140,
    flex: 0.1
  },
  {
    headerName: 'Exe. Date',
    field: 'exeDate',
    minWidth: 120,
    flex: 0.1
  },
  {
    headerName: 'Exe. Price',
    field: 'exePrice',
    minWidth: 100,
    flex: 0.1,
    type: 'rightAligned'
  },
  {
    headerName: 'Units',
    field: 'units',
    minWidth: 100,
    flex: 0.1,
    type: 'rightAligned',
    valueFormatter: ({ value }) => (value ? formatUnits(value) : '–')
  },
  {
    headerName: 'Amount',
    field: 'amount',
    minWidth: 140,
    flex: 0.1,
    type: 'rightAligned',
    sort: 'desc',
    sortable: true,
    cellRenderer: CurrencyCell({
      fieldName: 'amount',
      currencyFieldName: 'currency',
      variant: 'full'
    })
  }
]

export const DEFAULT_COLUMN_OPTIONS: ColDef = {
  sortable: false,
  unSortIcon: true
}
